import React, { Component } from "react";

import "./about.styles.scss";

class AboutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="AboutPage">
        <section className="about-intro-section">
          <h1 className="section-title">A little about Heartening</h1>
          <p className="about-mission-statement">
            Heartening is on a mission to show every unwanted item where it
            is wanted.
          </p>
          <p>
            This project is built on the belief that if unwanted items knew
            where they were needed, people would help them get there.
          </p>
          <p>
            Unwanted items usually wait years gathering dust in a closet, a
            garage, or storage unit before getting tossed into the landfill.
            Meanwhile, those very same items could answer the very pressing
            needs of people nearby. But, items don't know that. So, we must
            help them find their way.
          </p>
        </section>

        <section className="about-bio-section">
          <div className="about-bio-row">
            <img
              className="about-photo"
              src="https://prinsesstarta.s3.amazonaws.com/about-me-assets/kelley-rytlewski.png"
              alt="Kelley Rytlewski, founder of Heartening"
            />
            <p>
              This idea is starting small in Austin but has a heart as big as
              Texas. The hands behind Heartening belong to me, Kelley. Hi
              there! I'm the zero-waste eco-minded caretaker of Heartening. I
              am a scrappy Texas woman who cares deeply about rescuing items
              for reuse right here in my own community. I have no funding, no
              grants, and I'm not on anyone's payroll.
            </p>
          </div>

          <p>
            I began this project as an experiment, wondering "If people knew
            where their items were needed, would they still dump them
            anyway?". My heart was sick seeing perfectly good items tossed
            into dumpsters and left in the trashroom of my apartment
            building, watching loads of belongings tossed unceremoniously
            when neighbors moved out. I took to taping up signs in the trash
            rooms, listing where items could be donated. I left my cell
            number and people would message me with questions about random
            items and I'd research and add to the list. Then, it became a
            giant spreadsheet. Then, eventually, eventually, this website.
          </p>

          <div className="about-bio-row about-bio-row--reverse">
            <img
              className="about-photo"
              src="https://prinsesstarta.s3.amazonaws.com/about-me-assets/donation-bundle.png"
              alt="A beautifully organized donation bundle"
            />
            <p>
              This project is still a journey of learning and research for
              me. I continue to meticulously study where items are needed
              and wanted all over Austin. I catalog where to donate items
              right here on my website. I put my cowboy boots on the ground
              to do it myself, too. I pick up items from porches, haul,
              sort, clean, and organize to make beautiful donation bundles.
              I visit local causes to drop off, chat with staff and
              volunteers, and learn something new every day.
            </p>
          </div>
        </section>

        <section className="about-closing-section">
          <p>
            Each day, I believe more and more that we, as a community, are
            rich in what we share together, but poor in what we keep alone.
            I believe that we already have everything we need — we just need
            to share it. I believe that giving items should be more like
            gifting items. When we donate items with extra love, then
            strangers become neighbors and neighbors become friends. I
            believe Austin can set an example that will inspire the world.
            And that, to me, is Heartening.
          </p>
          <p>
            Tips help me keep this project going. If you find this project
            useful, you can support Heartening by sending tips through{" "}
            <a
              href="https://www.venmo.com/u/Heartening"
              target="_blank"
              rel="noopener noreferrer"
              className="link-to-outside-pages"
            >
              venmo @heartening
            </a>{" "}
            or{" "}
            <a
              href="https://www.buymeacoffee.com/heartening"
              target="_blank"
              rel="noopener noreferrer"
              className="link-to-outside-pages"
            >
              buy me a coffee.
            </a>
          </p>
          <p className="about-signoff">
            With love,
            <br />
            Kelley
          </p>

          <div className="about-contact-card">
            <p className="about-contact-name">Kelley Rytlewski</p>
            <p>
              Email:{" "}
              <span className="link-to-outside-pages">
                kelley@heartening.org
              </span>
            </p>
            <p>
              Instagram:{" "}
              <a
                href="https://www.instagram.com/hearteningaustin/"
                target="_blank"
                rel="noopener noreferrer"
                className="link-to-outside-pages"
              >
                @hearteningaustin
              </a>
            </p>
            <p>
              Venmo:{" "}
              <span className="link-to-outside-pages">@heartening</span>
            </p>
          </div>
        </section>
      </div>
    );
  }
}

export default AboutPage;
